import React from "react";
import { render } from "react-dom";
import { AppContainer } from "react-hot-loader";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { v4 as uuid } from "uuid";
import Root from "./app/components/Root";

import "event-source-polyfill";
import "nodep-date-input-polyfill";
import { initErrorReporting } from "helpers/error_reporting/error_reporting";
import AppReducers from "reducers/app";

const sessionId = uuid();
initErrorReporting(sessionId);

const store = createStore(
  AppReducers,
  composeWithDevTools(applyMiddleware(thunk))
);

const renderApp = (Component: JSX.Element) => {
  render(
    <AppContainer>{Component}</AppContainer>,
    document.getElementById("root")
  );
};

renderApp(<Root store={store} />);

if (module.hot) {
  module.hot.accept("app/components/Root", () => {
    renderApp(<Root store={store} />);
  });
}
